// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_V_GPU_PROFILES = 'v-gpu-profiles/SET_V_GPU_PROFILES_LIST';
